import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getSerialProduct(params) {
	return client.get("api/product-serial/data", {
		params: params,
	});
}

function getSerialTypeOption() {
	return client.get("api/options/serial-type");
}

function exportSerialProduct(params) {
	return client.get("api/product-serial/export", {
		params: params,
	});
}

export default {
	getSerialProduct,
	getSerialTypeOption,
	exportSerialProduct,
};